export default __webpack_public_path__ + "static/media/Yeti.e204fb65.png";